import {i_more} from "../../icons";

export function ButtonMore({children}) {
  return <button className="users__more">
    {i_more()}
    {children}
  </button>;
}
